import {
  hasEndpointStopped,
  isEndpointActive,
  hasAllStreamsStartedOrFailed
} from 'hooks/useStreamButtonState/utils';
import {
  STREAM_START_FAILED,
  STREAM_STOP_FAILED
} from '@shoflo/studio-redux/constants/StreamStates';

/**
 * @description Returns whether stream has started.
 * @param {Set<string>} sliStartedStreamIds
 * @param {*} stream
 */
export const hasStreamStarted = (sliStartedStreamIds, stream) => {
  return sliStartedStreamIds.has(stream._id) && isEndpointActive(stream);
};

/**
 * @description Returns whether stream has failed starting.
 * @param {Set<string>} sliStartedStreamIds
 * @param {string} streamId
 * @param {string} status
 */
export const hasStreamStartFailed = (sliStartedStreamIds, streamId, status) => {
  return sliStartedStreamIds.has(streamId) && status === STREAM_START_FAILED;
};

/**
 * @description Returns whether stream has stopped.
 * @param {Set<string>} sliStoppedStreamIds
 * @param {*} stream
 */
export const hasStreamStopped = (sliStoppedStreamIds, stream) => {
  return sliStoppedStreamIds.has(stream._id) && hasEndpointStopped(stream);
};

/**
 * @description Returns whether stream has failed stopping.
 * @param {Set<string>} sliStoppedStreamIds
 * @param {string} streamId
 * @param {string} status
 * @param {{}} error
 */
export const hasStreamStopFailed = (sliStoppedStreamIds, streamId, status) => {
  return sliStoppedStreamIds.has(streamId) && status === STREAM_STOP_FAILED;
};

/**
 * @description Ends the Start Stream SLI based on the stream status.
 * @param {*} streamEndpoints
 * @param {*} endStreamStartCallback
 * @param {Set<string>} sliStartedStreamIds
 */
export function endStreamStartMetric(
  streamEndpoints,
  endStreamStartCallback,
  sliStartedStreamIds,
  endStartAllStreamsWorkflow
) {
  let hasAnyStreamFailedToStart = false;
  streamEndpoints.forEach(stream => {
    if (hasStreamStarted(sliStartedStreamIds, stream)) {
      endStreamStartCallback({
        streamId: stream._id
      });
      sliStartedStreamIds.delete(stream._id);
    } else if (
      hasStreamStartFailed(sliStartedStreamIds, stream._id, stream.status)
    ) {
      endStreamStartCallback({
        streamId: stream._id,
        error: `Error starting the stream, streamId: ${stream._id}`
      });
      sliStartedStreamIds.delete(stream._id);
      hasAnyStreamFailedToStart = true;
    }
  });
  if (hasAllStreamsStartedOrFailed(streamEndpoints)) {
    endStartAllStreamsWorkflow({
      status: hasAnyStreamFailedToStart ? 'failed' : 'success'
    });
  }
}

/**
 * @description Ends the Stop Stream SLI based on the stream status.
 * @param {*} streamEndpoints
 * @param {*} endStreamStopCallback
 * @param {*} sliStoppedStreamIds
 */
export function endStreamStopMetric(
  streamEndpoints,
  endStreamStopCallback,
  sliStoppedStreamIds
) {
  streamEndpoints.forEach(stream => {
    if (hasStreamStopped(sliStoppedStreamIds, stream)) {
      endStreamStopCallback({
        streamId: stream._id
      });
      sliStoppedStreamIds.delete(stream._id);
    } else if (
      hasStreamStopFailed(sliStoppedStreamIds, stream._id, stream.status)
    ) {
      endStreamStopCallback({
        streamId: stream._id,
        error: `Error stopping the stream, streamId: ${stream._id}`
      });
      sliStoppedStreamIds.delete(stream._id);
    }
  });
}
